module.exports = __webpack_public_path__ + "fonts/e8efee929eb2218fdc84a27389f3968b.ttf";